import React, { useEffect, useState } from 'react'
import PageLoader from '@/components/common/PageLoader'

interface DelayedPageLoaderProps {
  delayMs?: number
}

const DelayedPageLoader: React.FC<DelayedPageLoaderProps> = ({ delayMs = 180 }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delayMs)
    return () => clearTimeout(t)
  }, [delayMs])

  if (!show) return null
  return <PageLoader />
}

export default DelayedPageLoader


